import { TOrder } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../axios';

const ENTITY = 'billing';

export const getMemberOrderByNoQueryKey = (orderNo: number | string) => [ENTITY, 'orders', orderNo];

export const getMemberOrderByNoQueryFn = async (orderNo: number | string): Promise<TOrder> => {
  const req = await axios.get(`${ENTITY}/orders/${orderNo}`);
  return req.data;
};

export const useGetMemberOrderByNoQuery = (orderNo: number | string) => {
  return useQuery<TOrder>({
    queryKey: getMemberOrderByNoQueryKey(orderNo),
    queryFn: () => getMemberOrderByNoQueryFn(orderNo),
    enabled: !!orderNo,
  });
};
